import { render, staticRenderFns } from "./SwamtReportParent.vue?vue&type=template&id=8633dc1a&scoped=true"
import script from "./SwamtReportParent.vue?vue&type=script&lang=js"
export * from "./SwamtReportParent.vue?vue&type=script&lang=js"
import style0 from "./SwamtReportParent.vue?vue&type=style&index=0&id=8633dc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8633dc1a",
  null
  
)

export default component.exports